module.exports = __webpack_public_path__ + "static/android-icon-192x192-5d37a8bc80ec3c3dc545f844732fc8bb.png";